import { useMemo } from 'react'
import { TASK_BOARD_ICONS } from 'Data/constants.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return TASK_BOARD_ICONS.find(i => i.id === props.iconId)
  }, [props.iconId])
}
